'use strict'

export let english_productDetails={
  themes: {
    plan: {
      title: "Roadmap"
    }
  }
};



// WEBPACK FOOTER //
// ./views/product/labels/english#productDetails.js